import styled from "@emotion/styled";
import React, { useState } from "react";
import { compassColors } from "src/utils/styling";
import ConfettiTadaStatic from "src/components/banner/confetti_data_static.svg";
import { Text } from "@components/core/Text";
import {
  fontP2Regular,
  fontP4Medium,
  fontP4Regular,
} from "src/design-system/styles/fonts";
import { resetFormElement } from "src/design-system/styles/resets";
import { useDisableScroll } from "src/hooks/scroll";
import { useGlobalEventListener } from "src/hooks/dom";
import { Modal } from "src/design-system/components/Modal/Modal";
import Button from "src/design-system/components/Button/Button";

export const AnimationContainer = styled.div`
  height: 50px;
  width: 50px;
  max-height: 50px;
  max-width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BannerContainer = styled.div`
  height: 60px;
  background-color: ${compassColors.sky};
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 600px;
  margin: 0 20px;
  align-items: center;
`;

export const HeadlineContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
`;

export const Headline = styled(Text)`
  ${fontP4Medium};
  margin-left: 16px;
`;

export const StaticImg = styled.img`
  height: 40px;
  min-height: 40px;
  width: 40px;
  margin-top: -6px;
`;

const OfferDetailsButton = styled.button`
  ${resetFormElement};
  ${fontP4Regular};
  text-decoration: underline;
  border: none;
  background: none;
  display: inline;
  padding: 0;
  outline: none;
  box-shadow: none;
  margin-top: 16px;
`;

export const ModalBody = styled.div`
  ${fontP2Regular};
  margin-bottom: 32px;
  p:last-child {
    margin-bottom: 0;
  }
  p:first-child {
    margin-top: 0;
  }
`;

function ModalComponent({ onClose }) {
  const [offerDetailsClicked, setOfferDetailsClicked] = useState(false);
  useDisableScroll();

  useGlobalEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      onClose();
    }
  });

  return (
    <Modal onClickOutside={onClose} onClose={onClose} includeCloseButton>
      <ModalBody>
        {!offerDetailsClicked && (
          <>
            <Text
              i18nKey="clinicianReferralBanner:offerActivatedModal:paragraph1"
              parent="P"
            />
            <Text
              i18nKey="clinicianReferralBanner:offerActivatedModal:paragraph2"
              parent="P"
            />
          </>
        )}
        {offerDetailsClicked && (
          <>
            <strong>
              <Text i18nKey="clinicianReferralBanner:offerDetailsModal:title" />
            </strong>
            <ul>
              <li>
                <Text i18nKey="clinicianReferralBanner:offerDetailsModal:paragraph1" />
              </li>
              <li>
                <Text i18nKey="clinicianReferralBanner:offerDetailsModal:paragraph2" />
              </li>
            </ul>
          </>
        )}
      </ModalBody>
      <Button onClick={onClose}>
        <Text i18nKey="clinicianReferralBanner:offerActivatedModal:continue" />
      </Button>
      {!offerDetailsClicked && (
        <OfferDetailsButton onClick={() => setOfferDetailsClicked(true)}>
          <Text i18nKey="clinicianReferralBanner:offerActivatedModal:seeOfferDetails" />
        </OfferDetailsButton>
      )}
    </Modal>
  );
}

export function ClinicianReferralBanner() {
  const [showModal, setShowModal] = useState(true);

  return (
    <BannerContainer>
      {showModal && <ModalComponent onClose={() => setShowModal(false)} />}
      <ColumnContainer>
        <StaticImg src={ConfettiTadaStatic} />
        <Headline i18nKey="clinicianReferralBanner:headline" parent="span" />
      </ColumnContainer>
    </BannerContainer>
  );
}
